import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PageSkeleton from "./skeletons/PageSkeleton";

const PublicLayout = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <PageSkeleton />
      </div>
    );
  }

  // Redirect authenticated users based on role (UI-based, not from backend)
  if (isAuthenticated) {
    // Keep device-auth approval page accessible even for authenticated users.
    if (location.pathname === "/device-auth/approve") {
      return <Outlet />;
    }

    const isLoginRoute = location.pathname === "/login";
    const redirectParam = new URLSearchParams(location.search).get("redirect");
    if (isLoginRoute && redirectParam && redirectParam.startsWith("/")) {
      return <Navigate to={redirectParam} replace />;
    }

    // Get user role from context or storage
    const userRole = user?.role;

    if (userRole) {
      // Chief admin goes to /clients
      if (userRole === "chief-admin" || userRole === "Chief Admin") {
        return <Navigate to="/clients" state={{ from: location }} replace />;
      } else {
        // All other users go to /projects
        return <Navigate to="/projects" state={{ from: location }} replace />;
      }
    } else {
      // If no user in context, try to get from storage
      try {
        const storedUser = JSON.parse(localStorage.getItem("user") || "null");
        if (storedUser) {
          const storedRole = storedUser.role;
          if (storedRole === "chief-admin" || storedRole === "Chief Admin") {
            return (
              <Navigate to="/clients" state={{ from: location }} replace />
            );
          } else {
            return (
              <Navigate to="/projects" state={{ from: location }} replace />
            );
          }
        }
      } catch (e) {
        // If parsing fails, default to projects
        return <Navigate to="/projects" state={{ from: location }} replace />;
      }
    }
  }

  return <Outlet />;

  // <div className="min-h-screen bg-gray-50">
  //   <TopNavigation />
  //   <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
  //     <Outlet />
  //   </main>
  // </div>
};

export default PublicLayout;
